import { render, staticRenderFns } from "./PaginationList.vue?vue&type=template&id=3a97d438&"
import script from "./PaginationList.vue?vue&type=script&lang=ts&"
export * from "./PaginationList.vue?vue&type=script&lang=ts&"
import style0 from "./PaginationList.vue?vue&type=style&index=0&id=3a97d438&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports